import { render, staticRenderFns } from "./TambahKeluhan.vue?vue&type=template&id=75439894&"
import script from "./TambahKeluhan.vue?vue&type=script&lang=js&"
export * from "./TambahKeluhan.vue?vue&type=script&lang=js&"
import style0 from "./TambahKeluhan.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports